import React from 'react';
import {Users, Package} from 'lucide-react';

interface DataLoadingStatusProps {
  marketersCount: number;
  productsCount: number;
  onFetchMarketers: () => void;
  onFetchProducts: () => void;
}

const DataLoadingStatus: React.FC<DataLoadingStatusProps> = ({
  marketersCount,
  productsCount,
  onFetchMarketers,
  onFetchProducts
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <div className="bg-brand-50 p-4 rounded-lg border border-brand-200">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Users className="h-5 w-5 text-brand-600" />
            <span className="font-medium text-brand-800">المسوقين المتاحين</span>
          </div>
          <span className="text-2xl font-bold text-brand-900">{marketersCount}</span>
        </div>
        {marketersCount === 0 && (
          <div className="mt-2">
            <button
              type="button"
              onClick={onFetchMarketers}
              className="text-sm text-brand-600 hover:text-brand-800"
            >
              إعادة تحميل المسوقين
            </button>
            <p className="text-xs text-gray-500 mt-1">
              عدد المسوقين المحملين: {marketersCount}
            </p>
          </div>
        )}
      </div>

      <div className="bg-green-50 p-4 rounded-lg border border-green-200">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Package className="h-5 w-5 text-green-600" />
            <span className="font-medium text-green-800">المنتجات المتاحة</span>
          </div>
          <span className="text-2xl font-bold text-green-900">{productsCount}</span>
        </div>
        {productsCount === 0 && (
          <button
            type="button"
            onClick={onFetchProducts}
            className="mt-2 text-sm text-green-600 hover:text-green-800"
          >
            إعادة تحميل المنتجات
          </button>
        )}
      </div>
    </div>
  );
};

export default DataLoadingStatus;
